<template>
  <div class="notification">
    <div class="gesture" :class="[`gesture${num}`, ani]"></div>
    <div class="t-container">
      <img class="t-desc" :src='imgSrc'>
    </div>
  </div>
</template>


<script>
export default {
  name: 'Notification',
  props: {
    num: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      img1: require('./s1-notice.png'),
      img2: require('./s2-notice.png'),
      img3: require('./s3-notice.png'),
      img4: require('./s4-notice.png'),
    }
  },
  computed: {
    imgSrc () {
      switch (this.num) {
        case 1:
          return this.img1;
        case 2:
          return this.img2;
        case 3:
          return this.img3;
        case 4:
          return this.img4;
        default:
          return this.img1;
      }
    },
    ani () {
      switch (this.num) {
        case 1:
          return 'shake';
        case 2:
          return 'shine';
        case 3:
          return '';
        case 4:
          return 'slide';
        default:
          return '';
      }
    }
  }
}
</script>

<style lang="less" scoped>
.notification {
  position: absolute;
  bottom: 14%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .gesture {
    margin-bottom: 2.5rem /* 40/16 */;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .gesture1 {
    width: 3.4375rem /* 55/16 */;
    height: 4.0625rem /* 65/16 */;
    background-image: url('./g-shake.png');
  }
  .gesture2 {
    width: 3.3125rem /* 53/16 */;
    height: 4.25rem /* 68/16 */;
    background-image: url('./g-press.png');
  }
  .gesture3 {
    width: 4.875rem /* 78/16 */;
    height: 4.0625rem /* 65/16 */;
    background-image: url('./g-blow.png');
  }
  .gesture4 {
    width: 4.25rem /* 68/16 */;
    height: 4.375rem /* 70/16 */;
    background-image: url('./g-rub.png');
  }
  .t-container {
    width: 23rem /* 368/16 */;
    height: 7.1875rem /* 115/16 */;
    background-image: url('./toast-container.png');
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    .t-desc {
      margin-top: 2.25rem /* 36/16 */;
      height: 2.6875rem /* 43/16 */;
    }
  }
}

.slide {
  animation: slide 1.5s linear infinite;
  animation-fill-mode: both;
}

.shine {
  animation: shine 1.5s linear infinite;
  animation-fill-mode: both;
}

.shake {
  animation: shake 1.5s linear infinite;
  animation-fill-mode: both;
}

@keyframes slide {
  from {
    transform: translate3d(-18px, 0, 0);
    opacity: 1;
  }
  to {
    transform: translate3d(18px, 0, 0);
    opacity: .1;
  }
}

@keyframes shine {
  from {
    opacity: .1;
  }
  to {
    opacity: 1;
  }
}

@keyframes shake {
  0%, 100% {
    transform-origin: 50% 100%;
    transform: rotate(10deg);
  }
  25%, 75% {
    transform-origin: 50% 100%;
    transform: rotate(0);
  }
  50% {
    transform-origin: 50% 100%;
    transform: rotate(-10deg);
  }
}
</style>
